module.exports = __webpack_public_path__ + "static/media/third_place_dark.8f43bb6d.svg";